<ion-card>
  <ion-card-header>
    <ion-card-title>Partnerek</ion-card-title>
    <ion-card-subtitle>
      Szervezetek és személyek, akikkel iratforgalmunk van. Az elektronikus
      kézbesítéshez szervezetnél BKSZ-postafiók (KRID vagy rövid név), személynél a
      természetes azonosítók kellenek – a hiányt itt jelezzük, még kiküldés előtt.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-segment [(ngModel)]="nezet" mode="ios" (ionChange)="nezetValt($any($event.detail.value))">
      <ion-segment-button value="szemely"><ion-label>Személyek</ion-label></ion-segment-button>
      <ion-segment-button value="szervezet"><ion-label>Szervezetek</ion-label></ion-segment-button>
    </ion-segment>

    <div class="ikt-fejsor">
      <ion-searchbar placeholder="Keresés névre, azonosítóra…" [(ngModel)]="szoveg"
                     [debounce]="300" (ionChange)="betolt()"></ion-searchbar>
      <ion-checkbox labelPlacement="end" [checked]="csakHianyos"
                    (ionChange)="csakHianyos = $event.detail.checked">
        Csak a hiányos adatúak
        <ion-badge color="warning" *ngIf="hianyosDb">{{ hianyosDb }}</ion-badge>
      </ion-checkbox>
      <ion-button size="small" (click)="uj()">
        <ion-icon slot="start" name="add-outline"></ion-icon>Új partner
      </ion-button>
      <ion-button size="small" fill="outline" (click)="importal('allomany')" [disabled]="importFut">
        <ion-icon slot="start" name="people-outline"></ion-icon>Dolgozók behúzása
      </ion-button>
      <ion-button size="small" fill="outline" (click)="duplikatumokBetolt()" [disabled]="duplFut">
        <ion-icon slot="start" name="git-merge-outline"></ion-icon>Duplikátumok keresése
      </ion-button>
      <ion-button size="small" fill="outline" (click)="importal('ber_alkalmazott')" [disabled]="importFut">
        <ion-icon slot="start" name="download-outline"></ion-icon>Bérszámfejtőből
      </ion-button>
      <ion-spinner name="crescent" *ngIf="importFut"></ion-spinner>
    </div>

    <!-- Szerkesztő -->
    <div *ngIf="szerkesztett" style="border:1px solid var(--ion-color-light-shade,#ddd);border-radius:8px;padding:10px;margin-bottom:12px">
      <h3 style="margin:0 0 8px;font-size:.95rem">
        {{ szerkesztett.uj ? 'Új partner' : szerkesztett.nev }}
      </h3>
      <div class="ikt-fejsor">
        <ion-select label="Típus" label-placement="stacked" interface="popover" [(ngModel)]="szerkesztett.tipus">
          <ion-select-option value="szemely">természetes személy</ion-select-option>
          <ion-select-option value="szervezet">szervezet</ion-select-option>
          <ion-select-option value="hatosag">hatóság</ion-select-option>
        </ion-select>
        <ion-input label="Név" label-placement="stacked" [(ngModel)]="szerkesztett.nev"></ion-input>
        <ion-select label="Postafiók típusa" label-placement="stacked" interface="popover"
                    [(ngModel)]="szerkesztett.kapu_tipus">
          <ion-select-option *ngFor="let k of KAPU_TIPUSOK" [value]="k.kulcs">{{ k.nev }}</ion-select-option>
        </ion-select>
      </div>

      <!-- Szervezet: BKSZ-postafiók.
           A KRID-et és a rövid nevet NEM kézzel gépeljük: a hivatalos névsorból (NISZ)
           választjuk ki, mert az elgépelt azonosító nem hibát ad, hanem kézbesíthetetlen
           küldeményt. A névsort a kiszolgáló tartja naprakészen (Beállítások). -->
      <div *ngIf="szerkesztett.tipus !== 'szemely'" style="margin-bottom:6px">
        <ion-input label="Keresés a hivatali kapus névsorban" label-placement="stacked"
                   [(ngModel)]="hivKeres" (ionInput)="hivKeresValt()"
                   placeholder="szervezet neve, rövid neve vagy KRID – a kiválasztott adat kitölti a mezőket"></ion-input>
        <div *ngIf="hivTalalatok.length" class="ikt-tabla-doboz" style="max-height:190px;overflow:auto">
          <table class="ikt-tabla">
            <tbody>
              <tr *ngFor="let h of hivTalalatok" style="cursor:pointer" (click)="hivatalValaszt(h)">
                <td style="width:16%"><b>{{ h.rovidnev }}</b></td>
                <td>{{ h.nev }}</td>
                <td style="width:14%">{{ h.krid || '—' }}</td>
                <td style="width:12%">{{ h.statusz === 'megszűnt' ? 'megszűnt' : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ion-note color="medium" *ngIf="hivUres" style="display:block;font-size:.76rem">
          Nincs találat. Ha a névsor még üres, a Beállítások → Hivatali kapu névsor fülön
          indítsd el a frissítést.
        </ion-note>
      </div>

      <div class="ikt-fejsor" *ngIf="szerkesztett.tipus !== 'szemely'">
        <ion-input label="KRID" label-placement="stacked" [(ngModel)]="szerkesztett.krid"></ion-input>
        <ion-input label="Rövid név" label-placement="stacked" [(ngModel)]="szerkesztett.rovidnev"></ion-input>
        <ion-input label="Adószám" label-placement="stacked" [(ngModel)]="szerkesztett.adoszam"></ion-input>
      </div>

      <!-- Személy: természetes azonosítók -->
      <div class="ikt-fejsor" *ngIf="szerkesztett.tipus === 'szemely'">
        <ion-input label="Születési név" label-placement="stacked" [(ngModel)]="szerkesztett.szuletesi_nev"></ion-input>
        <ion-input label="Anyja neve" label-placement="stacked" [(ngModel)]="szerkesztett.anyja_neve"></ion-input>
        <ion-input label="Születési hely" label-placement="stacked" [(ngModel)]="szerkesztett.szul_hely"></ion-input>
        <ion-input label="Születési idő" label-placement="stacked" type="date" [(ngModel)]="szerkesztett.szul_ido"></ion-input>
      </div>

      <div class="ikt-fejsor">
        <ion-input label="Irányítószám" label-placement="stacked" [(ngModel)]="szerkesztett.irsz"></ion-input>
        <ion-input label="Település" label-placement="stacked" [(ngModel)]="szerkesztett.telepules"></ion-input>
        <ion-input label="Cím" label-placement="stacked" [(ngModel)]="szerkesztett.cim"></ion-input>
        <ion-input label="E-mail" label-placement="stacked" [(ngModel)]="szerkesztett.email"></ion-input>
        <ion-input label="Telefon" label-placement="stacked" [(ngModel)]="szerkesztett.telefon"></ion-input>
      </div>

      <div class="ikt-gombsor">
        <ion-button size="small" (click)="ment()">Mentés</ion-button>
        <ion-button size="small" fill="clear" (click)="megse()">Mégse</ion-button>
      </div>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <!--  ══════════ AZONOS NEVŰ PARTNEREK ══════════
          A tömeges feladás egy ideig minden címzetthez új partnert hozott létre. A
          kapcsolati kód és a természetes azonosítók a RÉGI soron maradtak, a küldés
          viszont az újra hivatkozott – ezért „tűnt el" a kézzel beírt kód. A hiba
          javítva; itt a már keletkezett párok vonhatók össze. -->
    <div class="ikt-partner-kerdes" *ngIf="duplikatumok.length">
      <b>{{ duplikatumok.length }} azonos nevű partner-csoport.</b>
      Válaszd ki, melyik sort tartsuk meg – a többi hivatkozása (küldemények, iratok)
      átkerül rá, és ami csak rajtuk volt (kapcsolati kód, születési adatok), azt is
      átvesszük. A beolvasztott sor nem törlődik, csak inaktív lesz.
      <div class="sor" *ngFor="let cs of duplikatumok">
        <span class="nev">{{ cs.nev }}</span>
        <ion-select interface="popover" fill="outline" [(ngModel)]="duplValasztas[cs.kulcs]">
          <ion-select-option *ngFor="let p of cs.sorok" [value]="p.id">
            {{ p.forras }}{{ p.kapcsolati_kod ? ' · van kapcsolati kódja' : '' }}
            · {{ p.kuldemeny_db }} küldemény · {{ p.letrehozva }}
          </ion-select-option>
        </ion-select>
        <ion-button size="small" (click)="egyesit(cs)" [disabled]="duplFut">Összevonás</ion-button>
      </div>
    </div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th>Név</th>
            <th *ngIf="nezet === 'szervezet'">KRID / rövid név</th>
            <th>Postafiók</th>
            <th>Elérhetőség</th>
            <th>Forrás</th>
            <th>Kézbesíthető</th>
            <th>Művelet</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of lista">
            <td>
              <b>{{ p.nev }}</b>
              <div style="font-size:.76rem;color:var(--ion-color-medium-shade,#6b7280)"
                   *ngIf="p.tipus === 'szemely' && p.szuletesi_nev && p.szuletesi_nev !== p.nev">
                sz.: {{ p.szuletesi_nev }}
              </div>
            </td>
            <td *ngIf="nezet === 'szervezet'">
              <span class="iktszam" *ngIf="p.krid">{{ p.krid }}</span>
              <span *ngIf="p.rovidnev"> {{ p.rovidnev }}</span>
              <span *ngIf="!p.krid && !p.rovidnev">—</span>
            </td>
            <td>{{ p.kapu_tipus === 'nincs' ? '—' : p.kapu_tipus }}</td>
            <td style="font-size:.8rem">
              {{ p.email || '' }}
              <div>{{ [p.irsz, p.telepules, p.cim].join(' ').trim() }}</div>
            </td>
            <td style="font-size:.78rem">{{ p.forras }}</td>
            <td>
              <ion-badge color="success" *ngIf="!p.kapu_hiany?.length">rendben</ion-badge>
              <ion-badge color="warning" *ngIf="p.kapu_hiany?.length"
                         [title]="'Hiányzik: ' + p.kapu_hiany.join(', ')">
                hiányzik: {{ p.kapu_hiany.join(', ') }}
              </ion-badge>
            </td>
            <td>
              <ion-button size="small" fill="clear" (click)="szerkeszt(p)">Szerkesztés</ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="inaktival(p)">Inaktív</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!lista.length">
        {{ csakHianyos ? 'Minden partner adata rendben van.' : 'Nincs megjeleníthető partner.' }}
      </div>
    </div>
  </ion-card-content>
</ion-card>
